(() => {
  // Draw mode delegates all pointer visuals to the global `.mfr-custom-cursor`
  // so we only need to manage the canvas overlay and per-section activation.
  const customCursor = document.querySelector('[data-custom-cursor]');

    const initCursorDraw = (wrapper) => {
      if (!wrapper || wrapper.dataset.cursorDrawInitialized === 'true') return;
      wrapper.dataset.cursorDrawInitialized = 'true';

    const sectionId = wrapper.dataset.drawRoot;
    const strokeVar = wrapper.dataset.strokeVar || '--section-text';
    const section = (sectionId && document.getElementById(sectionId)) || wrapper.closest('.shopify-section');

    if (!section) return;

    const spacer = section.querySelector('.section-spacer') || wrapper.closest('.section-spacer');
    const canvas = wrapper.querySelector('.cursor-draw__canvas');
    const supportsHover = !window.matchMedia || window.matchMedia('(any-hover: hover)').matches;
    const usingCustomCursor = Boolean(customCursor) && supportsHover;

    if (!spacer || !canvas) return;

    const ctx = canvas.getContext('2d');
    const dpr = Math.min(window.devicePixelRatio || 1, 2);

    const resolveStrokeColor = () => {
      const sectionStyles = getComputedStyle(section);
      const colorFromVar = ((strokeVar && sectionStyles.getPropertyValue(strokeVar)) || '').trim();
      if (colorFromVar) return colorFromVar;

      const sectionColor = sectionStyles.color;
      if (sectionColor) return sectionColor;

      const rootStyles = getComputedStyle(document.documentElement);
      const rootVarColor = (rootStyles.getPropertyValue('--color-black') || '').trim();
      if (rootVarColor) return rootVarColor;

      const rootColor = rootStyles.color;
      if (rootColor) return rootColor;

      return '#111';
    };

    const strokeColor = resolveStrokeColor();
    wrapper.dataset.cursorDrawColor = strokeColor;

    if (usingCustomCursor) {
      customCursor.style.setProperty('--cursor-draw-icon-color', strokeColor);
    }

    const resize = () => {
      const rect = spacer.getBoundingClientRect();
      canvas.width = rect.width * dpr;
      canvas.height = rect.height * dpr;
      canvas.style.width = `${rect.width}px`;
      canvas.style.height = `${rect.height}px`;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };

    resize();
    window.addEventListener('resize', resize);

    let drawing = false;
    let points = [];
    const FADE_TIME = 700;

    const getPos = (evt) => {
      const rect = spacer.getBoundingClientRect();
      return {
        x: evt.clientX - rect.left,
        y: evt.clientY - rect.top
      };
    };

    const addPoint = (x, y, lift = false) => {
      points.push({ x, y, time: performance.now(), lift });
    };

    const drawFrame = () => {
      const now = performance.now();
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      ctx.lineJoin = 'round';
      ctx.lineCap = 'round';

      for (let i = 1; i < points.length; i += 1) {
        const p1 = points[i - 1];
        const p2 = points[i];

        if (p1.lift || p2.lift) continue;

        const age = now - p2.time;
        if (age > FADE_TIME) continue;

        const dx = p2.x - p1.x;
        const dy = p2.y - p1.y;
        const dist = Math.sqrt(dx * dx + dy * dy);
        const speed = dist;
        const minW = 0.5;
        const maxW = 2;
        const clampedSpeed = Math.min(speed, 20);
        const width = maxW - (clampedSpeed / 20) * (maxW - minW);
        ctx.lineWidth = width;

        const alpha = 1 - age / FADE_TIME;
        ctx.strokeStyle = strokeColor;
        ctx.globalAlpha = alpha;

        ctx.beginPath();
        const cx = (p1.x + p2.x) * 0.5;
        const cy = (p1.y + p2.y) * 0.5;
        ctx.moveTo(p1.x, p1.y);
        ctx.quadraticCurveTo(p1.x, p1.y, cx, cy);
        ctx.stroke();
      }

      ctx.globalAlpha = 1;
      points = points.filter((point) => now - point.time < FADE_TIME);
      requestAnimationFrame(drawFrame);
    };

    requestAnimationFrame(drawFrame);

    spacer.addEventListener('pointerenter', () => {
      if (usingCustomCursor && customCursor) {
        const color = wrapper.dataset.cursorDrawColor;
        if (color) customCursor.style.setProperty('--cursor-draw-icon-color', color);
        customCursor.classList.add('is-draw-mode');
      }
    });

    spacer.addEventListener('pointerdown', (evt) => {
      drawing = true;
      document.body.classList.add('is-drawing');
      const pos = getPos(evt);
      addPoint(pos.x, pos.y, true);
    });

    spacer.addEventListener('pointermove', (evt) => {
      if (!drawing) return;
      const pos = getPos(evt);
      const last = points[points.length - 1];

      if (last && !last.lift) {
        const dx = pos.x - last.x;
        const dy = pos.y - last.y;
        const dist = Math.sqrt(dx * dx + dy * dy);
        const step = 2;
        const steps = Math.floor(dist / step);

        for (let i = 1; i <= steps; i += 1) {
          const t = i / (steps + 1);
          const ix = last.x + dx * t;
          const iy = last.y + dy * t;
          addPoint(ix, iy);
        }
      }

      addPoint(pos.x, pos.y);
    });

    const stopDrawing = () => {
      drawing = false;
      document.body.classList.remove('is-drawing');
    };

    spacer.addEventListener('pointerup', stopDrawing);
    spacer.addEventListener('pointerleave', () => {
      stopDrawing();
      if (usingCustomCursor && customCursor) customCursor.classList.remove('is-draw-mode');
    });
    window.addEventListener('pointerup', stopDrawing);
  };

  const initAll = () => {
    const wrappers = document.querySelectorAll('[data-cursor-draw]');
    wrappers.forEach(initCursorDraw);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();
